// Public presentation only. Account usernames and provider names never enter this policy.
const RIDER_COLORS = [
    { name: 'Green', hex: '#00d87f' },
    { name: 'Gold', hex: '#f0b429' },
    { name: 'Blue', hex: '#60a5fa' },
    { name: 'Purple', hex: '#c084fc' },
    { name: 'Orange', hex: '#fb923c' },
    { name: 'Pink', hex: '#f472b6' },
];
function generatedName(playerId) { return `Skier ${playerId.slice(-4).toUpperCase()}`; }
function shownName(playerId, mode, name) {
    if (mode === 'public' && name) return name;
    if (mode === 'masked' && name) return `${name[0]}••••${name[name.length - 1]}`;
    return generatedName(playerId);
}
function riderChroma(value, playerId = '') {
    return Number.isInteger(value) && value >= 0 && value < RIDER_COLORS.length
        ? value : (parseInt(playerId.slice(-4), 16) || 0) % RIDER_COLORS.length;
}
module.exports = { RIDER_COLORS, generatedName, shownName, riderChroma };
